module.exports = __webpack_public_path__ + "img/everyday.f829a77f.png";